import request from "@utils/request";

export function getVolume (query) {
    return request({
        url: "search/volume",
        method: "post",
        data: query
    });
}